/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { clientEnumSchema } from "./clientEnumSchema.ts";
import { paymentProviderEnumSchema } from "./paymentProviderEnumSchema.ts";

export const mobileOrderInitPaymentRequestSchema = z.object({
	by_bonuses: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.optional()
		.default("0.00"),
	order: z.uuid(),
	amount: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.optional(),
	email: z.email().min(1).optional(),
	provider_type: paymentProviderEnumSchema
		.optional()
		.describe(
			"* `ALFA_BANK` - ALFA_BANK\n* `PAYGINE` - PAYGINE\n* `YOOKASSA` - YOOKASSA\n* `TERMINAL` - TERMINAL\n* `CASH` - CASH\n* `YANDEX_BADGE` - YANDEX_BADGE\n* `PAYMENT_TRACKER` - PAYMENT_TRACKER\n* `KASPI` - KASPI",
		),
	delivery_cost: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.optional(),
	disable_back_btn: z.boolean().optional(),
	client: clientEnumSchema
		.optional()
		.describe(
			"Приложение, из которого запущена оплата. Для ios после оплаты гость возвращается в приложение по схеме из настроек организации.\n\n* `ios` - iOS-приложение",
		),
	items: z
		.array(z.uuid())
		.optional()
		.describe(
			"Список id позиций (MobileOrderItem.id) которые помечаются оплаченными по успешному коллбэку. Применяется только в TS-режиме; уже оплаченные позиции игнорируются.",
		),
});
